import { EWorldAction } from 'libs/utils/world/worldTypes';
import { MapMouseEvent } from 'mapbox-gl';
import { useContext, useEffect, useState } from 'react';
import { ICoordinates } from 'react-give-me-map';
import { MapRef } from 'react-map-gl';
import { CtxEdit } from 'session/ctxEdit';

interface Params {
    mapRef: MapRef;
    onCoordinateSelected: (coordinate: ICoordinates) => void;
}

export const useSelectMapPosition = (params: Params) => {
    const { mapRef, onCoordinateSelected } = params;

    const ctxEdit = useContext(CtxEdit);
    const [isSelectActive, setIsSelectActive] = useState(false);

    useEffect(() => {
        const mapOnClick = (e: MapMouseEvent) => {
            if (isSelectActive) {
                setIsSelectActive(false);
                onCoordinateSelected({
                    lng: e.lngLat.lng,
                    lat: e.lngLat.lat
                });
            }
        };

        const onKeyDown = (e: KeyboardEvent) => {
            if (isSelectActive && e.key === 'Escape') {
                setIsSelectActive(false);
                e.stopPropagation();
            }
        };

        window.addEventListener('keydown', onKeyDown);
        mapRef?.once('click', mapOnClick);

        return () => {
            mapRef?.off('click', mapOnClick);
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [mapRef, isSelectActive]);

    useEffect(() => {
        const newAction = isSelectActive ? EWorldAction.POINT_SELECT : EWorldAction.SELECT;
        ctxEdit.setWorldAction(newAction);
    }, [isSelectActive]);

    return { isSelectActive, setIsSelectActive };
};
